import React from 'react';
import { PatientControlCardComponent } from '../../../../components/Cards';
import {
  matchPath,
  withRouter,
  RouteComponentProps,
  generatePath,
} from 'react-router';
import { usePatient } from '../../../../contexts/patient';
import produce from 'immer';
import { putPatient } from '../../../../apis/patient';

const PatientControlCard = (props: RouteComponentProps<{}>) => {
  const { patient, setPatient } = usePatient();
  const match = matchPath<{ organizationId: string; patientId: string }>(
    props.location.pathname,
    {
      path: '/organization/:organizationId/patient/:patientId',
    },
  );
  const gPath = match
    ? generatePath(
        '/organization/:organizationId/patient/:patientId/myChoices',
        match.params,
      )
    : undefined;
  return (
    <PatientControlCardComponent
      reviewPath={gPath}
      archived={patient && !patient.active}
      active={!!patient}
      onSetActive={async active => {
        if (!patient || !patient.id) return;
        const mPatient = produce(patient, draft => {
          draft.active = active;
        });
        if (!mPatient || !mPatient.id) return;

        const updatedPatient = await putPatient(mPatient.id, mPatient);
        setPatient(updatedPatient);
      }}
      onFinalize={() => {}}
    />
  );
};

export default withRouter(PatientControlCard);
